export default function checkForOwnQuote(
  quote: { price: string } | undefined,
  quoteList: { price: string }[],
) {
  if (quote == null || quoteList.length === 0) return null;

  const quotePrice = quote.price;
  const samePriceOwnQuote =
    quoteList.find((myQuote) => myQuote.price === quotePrice) ?? null;

  return samePriceOwnQuote;
}
